import React, { useEffect, useRef } from "react";
import ContactsEmailInput from "./ContactsEmailInput";
import ContactsPhoneInput from "./ContactsPhoneInput";
import InsuranceStartDatePicker from "./InsuranceStartDatePicker";
import { makeStyles } from "@material-ui/core";
import Title from "./Title";
import { ApplicationState } from "../store";
import { connect, ConnectedProps } from "react-redux";
import InsuranceReceiveTypeSelector from "./InsuranceReceiveTypeSelector";
import focusAndScroll from "../helpers/refs/focusAndScroll";

const connector = connect((state: ApplicationState) => state, {});
type ContactSectionProps = ConnectedProps<typeof connector> & {};

const useStyles = makeStyles(theme => ({
  component: {
    display: "flex",
    flexDirection: "column",
    margin: `${theme.spacing(2)}px 0`,
    "& > div:not(:first-child)": {
      margin: `${theme.spacing(1.5)}px 0`,
    },
  },
}));

const ContactSectionComponent: React.FC<ContactSectionProps> = (props: ContactSectionProps) => {
  const css = useStyles();

  const refs = {
    email: useRef<HTMLInputElement>(null),
    phone: useRef<HTMLInputElement>(null),
  } as Record<string, React.RefObject<HTMLInputElement>>;

  const errorTrigger = props.profile?.errorTrigger;

  useEffect(() => {
    const errorFields: string[] = [];
    props.profile?.email.state && errorFields.push("email");
    props.profile?.phone.state && errorFields.push("phone");
    errorFields.length && focusAndScroll(refs[errorFields[0]]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorTrigger]);

  return (
    <div className={css.component}>
      <Title title={props.texts?.contactsSectionHeader ?? "Kontaktuppgifter"} />
      <ContactsEmailInput forwardedRef={refs.email} />
      <ContactsPhoneInput forwardedRef={refs.phone} />
      <InsuranceReceiveTypeSelector />
    </div>
  );
};
export const ContactSection = connector(ContactSectionComponent);

const ContactSectionWithStartDateComponent: React.FC<ContactSectionProps> = (props: ContactSectionProps) => {
  const css = useStyles();

  const refs = {
    startDate: useRef<HTMLInputElement>(null),
    email: useRef<HTMLInputElement>(null),
    phone: useRef<HTMLInputElement>(null),
  } as Record<string, React.RefObject<HTMLInputElement>>;

  const errorTrigger = props.profile?.errorTrigger;

  useEffect(() => {
    const errorFields: string[] = [];
    props.insurance?.startDate.hasError && errorFields.push("startDate");
    props.profile?.email.state && errorFields.push("email");
    props.profile?.phone.state && errorFields.push("phone");
    errorFields.length && focusAndScroll(refs[errorFields[0]]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorTrigger]);

  const hideStartDate = props.inputs.brand.toLowerCase() === "polestarforetag" && props.profile?.isCarNew;

  return (
    <div className={css.component}>
      <Title title={props.texts?.billingSectionHeader ?? "Datum & Betalning"} />
      {!hideStartDate && <InsuranceStartDatePicker forwardedRef={refs.startDate} />}
      <ContactsEmailInput forwardedRef={refs.email} />
      <ContactsPhoneInput forwardedRef={refs.phone} />
      <InsuranceReceiveTypeSelector />
    </div>
  );
};
export const ContactSectionWithStartDate = connector(ContactSectionWithStartDateComponent);
